import { useEffect, useState } from "react";
import TableTemplate from "./TableTemplate";
import { getFlexibleUsersPaginated } from "../../../redux/thunk";
import { useAppDispatch } from "../../../redux/hooks";

const Flexible = ({ activeTab }: { activeTab: string }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [searchedUser, setSearchedUser] = useState("");
    const [data, setData] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const dispatch = useAppDispatch();

    useEffect(() => {
        setIsLoading(true);
        const timeoutId = setTimeout(() => {
            dispatch(getFlexibleUsersPaginated({ page, limit: 20, search: searchedUser }))
                .then((response: any) => {
                    const resData = response?.payload;
                    const rows =
                        resData?.results ||
                        resData?.data ||
                        resData?.customers ||
                        resData?.users ||
                        (Array.isArray(resData) ? resData : []);
                    setData(rows);
                    const totalRecords = resData?.pagination?.totalElements || resData?.pagination?.total ||
                        (resData?.pagination?.totalPages ? resData.pagination.totalPages * 20 : rows.length);
                    setTotal(totalRecords || 0);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [dispatch, page, searchedUser]);

    return (
        <section>
            <TableTemplate
                activeTab={activeTab}
                isLoading={isLoading}
                searchedUser={searchedUser}
                setSearchedUser={(user: string) => {
                    setSearchedUser(user);
                    setPage(1); 
                }}
                data={data}
                currentPage={page}
                setCurrentPage={setPage}
                totalItems={total}
            />
        </section>
    );
};

export default Flexible;
